module.exports = __webpack_public_path__ + "img/Logo-Circle.056b3d07.png";